import Client from './client'
import UserResource from './resources/user'
import PasswordResource from './resources/password'
import ProductResource from './resources/product'
import SupplierResource from './resources/supplier'
import BookingResource from './resources/booking'
import GiftcardResource from './resources/giftcard'
import InvoiceResource from './resources/invoices'
import BookingDateResource from './resources/booking-dates'
import AccountResource from './resources/account'

const client = new Client()

export const users = new UserResource(client)
export const passwords = new PasswordResource(client)
export const products = new ProductResource(client)
export const suppliers = new SupplierResource(client)
export const booking = new BookingResource(client)
export const dates = new BookingDateResource(client)
export const giftcard = new GiftcardResource(client)
export const invoices = new InvoiceResource(client)
export const account = new AccountResource(client)

export { Client }
export * from './types'
